export const experimentAssignments = [
  //  To track an experiment assignment (the user is in the audience in control or treatment), add an object in this format
  // {
  //   jira: 'JIRA-1234', // the ID of the experiment in experiment::assignments
  //   ldFlag: 'jira-1234-ld-flag-string-here', // the LD flag string to use
  //   eventNames: [], // other miscellaneous strings to track (leave empty if none), see experiment::assignments table for details
  // },
  {
    jira: 'CAT-2564',
    ldFlag: 'cat-2564-improve-user-status-states',
    eventNames: [],
  },
  {
    jira: 'CAT-2592',
    ldFlag: 'cat-2592-dashboard-legacy-upsel-v-2',
    eventNames: [],
  },
  {
    jira: 'CAT-2621',
    ldFlag: 'cat-2621-rippling-dashboard-test-v-2',
    eventNames: [],
  },
  {
    jira: 'CAT-2622',
    ldFlag: 'cat-2622-dashboard-rippling-payroll-v-1',
    eventNames: [],
  },
  {
    jira: 'CAT-2616',
    ldFlag: 'cat-2616-auto-import-users-v-1',
    eventNames: [],
  },
  {
    jira: 'CAT-2623',
    ldFlag: 'cat-2623-rippling-cs-banner-on-timesheets',
    eventNames: [],
  },
  {
    jira: 'CAT-2625',
    ldFlag: 'cat-2625-rippling-xs-after-custom-export',
    eventNames: [],
  },
  {
    jira: 'CAT-2642',
    ldFlag: 'cat-2642-new-to-payroll-question-rippling-xs',
    eventNames: [],
  },
  {
    jira: 'CAT-2620',
    ldFlag: 'cat-2620-learning-center-experiment',
    eventNames: [],
  },
  {
    jira: 'CAT-2644',
    ldFlag: 'cat-2644-rxs-for-trial-accounts',
    eventNames: [],
  },
  {
    jira: 'CAT-2639',
    ldFlag: 'cat-2639-sans-onboarding',
    eventNames: [],
  },
  {
    jira: 'CAT-2617',
    ldFlag: 'cat-2617-magic-schedule-importer',
    eventNames: [],
  },
];
